export const getById = (id: string | number, templates: any) => {
  const result = templates.filter((t: any) => t.id === id)
  return result.length ? result[0] : null;
};